import axios from "axios";
import { memoizeFunc } from "client/utils/helpers";

export const isLocal = process.env.NODE_ENV === "development";
export const isTest = process.env.NODE_ENV === "test";

export const mockURL = () => (isLocal || isTest ? "http://localhost:9044" : "");

export const sflAPI = memoizeFunc(() =>
  axios.create({
    baseURL: `${mockURL()}/rest/model/sdg/savedforlater/SavedForLaterActor`,
  }),
);

export const csrfAPI = memoizeFunc(() =>
  axios.create({
    baseURL: `${mockURL()}/rest/model/atg/rest/SessionConfirmationActor`,
  }),
);
